import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 8h1v8","key":"svg-0"}]]

const IconNumber1Small = createReactComponent('outline', 'number-1-small', 'Number1Small', __iconNode);

export default IconNumber1Small;